import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Appointment } from "models";

export const useDmsRefreshMutation = () =>
  useTypedMutation<Appointment, void>({
    mutationFn: async appointment => {
      await ApiInstance.post("/appointments/refresh", { appointment_id: appointment.id }, ENV.dmsAccessorBaseURL);
    },
    onSuccess: () => typedQueryClient.invalidateQueries(AppointmentDetailsKeys.view)
  });
